import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Download, ZoomIn, ZoomOut } from "react-feather";
import { isEmpty } from 'ramda';
import classnames from 'classnames';

import FileIcon from "../FileIcon/FileIcon";
import { isImage } from '../../helpers/AttachmentUtils';

class AttachmentView extends Component {
  static propTypes = {
    attachmentId: PropTypes.string,
    attachment: PropTypes.object,
    downloadAttachment: PropTypes.func,
    isInModal: PropTypes.bool,
    onClickOutsideOfAttachment: PropTypes.func //This function is called when a click is made outside of the preview image
  };

  constructor(props) {
    super(props);
    this.state = {
      imgOrientation: '',
      imgTallerThanWindow: false,
      viewLarger: false
    };
  }

  componentDidMount() {
    const { attachment, attachmentId, downloadAttachment } = this.props;
    isEmpty(attachment) && downloadAttachment(attachmentId);
  }

  componentWillUnmount() {
    this.setState({ viewLarger: false });
  }

  onImgLoad = ({target:img}) => {
    const imgOrientation = img.naturalWidth > img.naturalHeight ? 'landscape' : 'portrait';
    const imgTallerThanWindow = img.naturalHeight > window.innerHeight;
    this.setState({
      imgOrientation,
      imgTallerThanWindow
    });
  };

  onClickOutsideOfAttachment = event => {
    //Check to make sure we are clicking the div it self and not any of it's children
    if (event.target === event.currentTarget) {
      this.props.onClickOutsideOfAttachment(event);
    }
  }

  toggleViewMode = () => this.setState({ viewLarger: !this.state.viewLarger });

  render() {
    const { attachment, attachmentId, isInModal } = this.props;
    const { imgOrientation, imgTallerThanWindow, viewLarger } = this.state;

    const canEnlarge = isInModal && imgOrientation === 'portrait' && imgTallerThanWindow;
    return(
      attachment && !isEmpty(attachment) ? (
        <div
          className={classnames({
            "attachment-view": true,
            'expanded': viewLarger
          })}
          data-qa={`attachment-view-${attachmentId}`}
        >
          <div className={classnames({
            "attachment-meta": true,
            "attachment-meta-in-modal": isInModal
          })}>
            <span className="attachment-type-icon">
              <FileIcon type={attachment.mediaType} size={20}/>
            </span>
            <span className="attachment-filename">{attachment.fileName}</span>
            {canEnlarge &&
              <button className="toggle-view-mode" onClick={this.toggleViewMode}>
                {viewLarger ? (
                  <ZoomOut size={20}/>
                ) : (
                  <ZoomIn size={20}/>
                )}
              </button>
            }
            <a
              href={attachment.downloadUrl}
              download={attachment.fileName}
              className="download-link"
            >
              <Download size={16}/>
              <span>Download</span>
            </a>
          </div>
          {/*TODO: Determine what to do if attachment is not an image */}
          {isImage(attachment) && attachment.displayUrl &&
            <div
              className="attachment-container"
              onClick={this.onClickOutsideOfAttachment}
            >
              <img
                className={classnames({
                  "can-enlarge": canEnlarge,
                  'expanded': viewLarger
                })}
                onLoad={this.onImgLoad}
                src={attachment.displayUrl}
                alt={attachment.fileName}
                onClick={canEnlarge ? this.toggleViewMode : undefined}
              />
            </div>
          }
        </div>

      ) : (
        <p>No attachment available</p>
      )
    );
  }
}

export default AttachmentView;
